import React, { useEffect, useRef } from 'react';
import { Camera, CameraType } from 'react-camera-pro';
import { Dialog, Stack, styled, IconButton } from '@mui/material';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';
import { StyledParams } from 'types/common';
import { useFlash } from 'contexts/flash';
type DialogConfirmType = {
  isOpen: boolean;
  onClose: () => void;
  onCapture: (image: string) => void;
};
export const CameraCustom = ({ isOpen, onClose, onCapture }: DialogConfirmType) => {
  const { setFlash } = useFlash();
  const camera = useRef<CameraType>(null);
  useEffect(() => {
    const checkCameraPermission = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        stream.getTracks().forEach((track) => track.stop());
      } catch (err) {
        setFlash({ type: 'error', message: 'Không thể truy cập camera:' });
      }
    };

    if (isOpen) {
      checkCameraPermission();
    }
  }, [isOpen]);
  return (
    <DialogStyled open={isOpen} onClose={onClose}>
      <WrapperDialog>
        <IconButton
          onClick={() => camera.current && camera.current.switchCamera()}
          sx={{
            position: 'absolute',
            top: 16,
            right: 16,
            background: 'white',
            borderRadius: '50%',
            padding: 1,
            zIndex: 50,
            ':hover': {
              background: 'white'
            }
          }}>
          <CameraswitchIcon />
        </IconButton>
        <Camera
          ref={camera}
          facingMode={'environment'}
          errorMessages={{
            noCameraAccessible:
              'No camera device accessible. Please connect your camera or try a different browser.',
            permissionDenied: 'Permission denied. Please refresh and give camera permission.',
            switchCamera:
              'It is not possible to switch camera to different one because there is only one video device accessible.',
            canvas: 'Canvas is not supported.'
          }}
        />
        <IconButton
          onClick={() => {
            if (camera.current) {
              const photo = camera.current.takePhoto() as string;
              onCapture(photo);
            }
          }}
          sx={{
            position: 'absolute',
            bottom: 24,
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'white',
            borderRadius: '50%',
            padding: 2
          }}>
          <CameraAltIcon />
        </IconButton>
      </WrapperDialog>
    </DialogStyled>
  );
};
const DialogStyled = styled(Dialog)(({ theme }: StyledParams) => ({
  [theme.breakpoints.up('sm')]: {
    '.MuiDialog-paper': {
      maxWidth: '450px'
    }
  },
  borderRadius: '20px',
  '.MuiDialog-paper': {
    margin: 0,
    width: '100%',
    minHeight: '100dvh'
  }
}));
const WrapperDialog = styled(Stack)(() => ({
  flex: 1,
  padding: '15px 32px 32px 32px'
}));
